


















import Vue from 'vue'
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import Gallery from '@/modules/cms/modules/gallery/model/Gallery'
import {notify} from '@/modules/core/notification';

/**
 * Solicita al usuario la confirmación para la eliminación de una galería
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ConfirmDeleteGallery extends Vue {
    /**
     * Controla la visibilidad del modal de confirmación
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    @Prop({type: Gallery, default: () => new Gallery()})
    public gallery: Gallery

    public removing = false

    /**
     * Solicita a la aplicación la eliminación de una galería
     */
    public async remove () {
        this.removing = true
        const id = this.gallery.id
        await this.$store.dispatch('cms/gallery/deleteGallery', this.gallery)

        this.$emit('input', false)
        this.removing = false

        notify(`Se ha eliminado correctamente la galería ${id}`)
        // Si el modal es abierto desde el detalle de la galería el componente
        // navegará hacia la pantalla que muestra la lista galerías
        this.$route.name === 'galleryDetail' && await this.$router.replace({name: 'galleryList'})
    }

    /**
     * Captura cualquier error producido por el componente y cierra el modal
     * de confirmación
     */
    public errorCaptured () {
        this.removing = false
        this.$emit('input', false)
    }
}
